import { getActiveRestaurantId } from "../utils/activeRestaurant";
import { useEffect, useState } from "react";
import { ILoginInfo } from "../models/ILoginInfo";
import { decrypt } from "../utils/Util";
import WorkingHoursManager from "../working-hours-module/components/WorkingHoursManager";

export default function WorkingHoursPage() {
  const [restaurantId, setRestaurantId] = useState("");

  useEffect(() => {
    const userJson = localStorage.getItem("user");
    if (userJson) {
      const u: ILoginInfo = JSON.parse(decrypt(userJson));
      setRestaurantId(getActiveRestaurantId());
    }
  }, []);

  return (
    <div style={{ padding: "24px", maxWidth: 960, margin: "0 auto" }}>
      <div style={{ marginBottom: 22 }}>
        <h4 style={{ fontWeight: 800, color: "#111827", marginBottom: 4 }}>
          <i className="bi bi-clock-fill me-2" style={{ color: "#f59e0b" }}></i>Çalışma Saatleri
        </h4>
        <p style={{ color: "#6b7280", fontSize: "0.88rem", margin: 0 }}>
          Restoranınızın şu anki durumunu görün, gerekirse anında kapatın; haftalık programı ve özel günleri yönetin.
        </p>
      </div>

      {restaurantId ? (
        <WorkingHoursManager key={restaurantId} restaurantId={restaurantId} />
      ) : (
        <div style={{ textAlign: "center", padding: "60px 0", color: "#9ca3af" }}>
          <i className="bi bi-shop" style={{ fontSize: "2.5rem", display: "block", marginBottom: 10 }}></i>
          <span style={{ fontSize: "0.9rem" }}>Hesabınıza bağlı bir restoran bulunamadı.</span>
        </div>
      )}
    </div>
  );
}
